/**
 * @generated SignedSource<<c07d00f5e792e262cbeb2932d0fe1d09>>
 * @relayHash 67ffcfecc421e8e4dfda0782b8958427
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9672c4ab2d72ccf8b38ea45a79b21402ec2540bc4c7d2824763ec9360642dcf2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9672c4ab2d72ccf8b38ea45a79b21402ec2540bc4c7d2824763ec9360642dcf2",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
